import React from "react";
import { Pagination } from "react-admin";

export const MyListPagination = (props) => (
  <Pagination perPage={100} rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);
